<template>
  <v-card class="pt-5" elevation="0">
    <v-card-text>
      <loading-block v-if="!loaded"></loading-block>
      <v-form ref="addForm" lazy-validation v-else>
        <!-- <div class="text-center my-5">
          <v-pagination :total-visible="10" :circle="true" v-model="page" :length="pageCount"></v-pagination>
        </div>-->
        <v-data-table
          class="py-3 pb-5 tabulardata"
          :headers="headers"
          :items="allergensItems"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
        >
          <template v-slot:item.name="{ item }">
            <v-checkbox
              class="tbl-chekbox"
              v-model="item.active"
              color="primary"
              :label="item.name"
            ></v-checkbox>
          </template>
          <template v-slot:item.presence="{ item }">
            <v-select
              v-model="item.presence"
              :items="[
                {
                  text: 'Contains',
                  value: 'contains'
                },
                {
                  text: 'May contain',
                  value: 'may contain'
                }
              ]"
            ></v-select>
          </template>
          <template v-slot:no-data>
            <p class="mb-0">No data.</p>
          </template>
        </v-data-table>
      </v-form>
    </v-card-text>

    <v-card-text class="text-right mt-0 pt-0 pb-0" v-if="loaded">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            @click="sync()"
            v-on="on"
            small
            dark
            color="primary"
            class="mr-2"
            depressed
          >Save Changes</v-btn>
        </template>
        <span>SYNC</span>
      </v-tooltip>
    </v-card-text>
  </v-card>
</template>

<script>
import { AllergenAPI } from '@/clients/product/allergen.api'
import { ProductAPI } from '@/clients/product/product.api'
import Helper from '@/utility/Helpers'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    LoadingBlock
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      loaded: false,
      headers: [
        { text: 'Allergen', value: 'name', sortable: true },
        { text: 'Presence', value: 'presence', sortable: true }
      ],
      normalValidation: [
        v => !!v || 'Field is required'
      ],
      allergensItems: [],
      productAllergens: []
    }
  },
  computed: {

    ...mapGetters({
      activeItem: 'product/activeItem',
      getAllergenes: 'allergen/list'
    })
  },

  created() {
    if (this.activeItem.id) {
      this.fetchSyncedAllergens()
    }
  },
  methods: {

    async fetchSyncedAllergens() {
      try{
        await this.setAllergenList()

        let res = await ProductAPI.fetchSyncedAllergens(this.activeItem.id)
        if (res.status === 200) {
          this.productAllergens = res.data.payload
        }
        this.fetchMasterAllergens()
      }catch(err){
        this.productAllergens = []
        this.loaded = true
        if(this.getAllergenes.length>0){
          this.fetchMasterAllergens()
        }
      }
    },

    async fetchMasterAllergens() {
      const self = this
      
      // await AllergenAPI.list()
      this.loaded = true
      var productAllergensIds = Helper.getFieldValueInArray(this.productAllergens, 'id')
      // Now chek if this terpene id is preset
      this.getAllergenes.map(item => {
        if (_.indexOf(productAllergensIds, item.id) > -1) {
          let dataArr = this.productAllergens.filter(fitem => fitem.id === item.id)
          // Get the object
          self.allergensItems.push({
            allergen_id: item.id,
            // name: item.allergen,
            presence: dataArr[0].ProductAllergen.presence,
            active: true,
            name: item.allergen
          })
        } else {
          self.allergensItems.push({
            allergen_id: item.id,
            // name: item.allergen,
            presence: '',
            active: false,
            name: item.allergen
          })
        }
      })
    },

    /**
     * Sync
     */
    async sync() {
      if (this.$refs['addForm'].validate()) {
        try {
          let activeAllergens = this.allergensItems.filter(item => item.active === true)
          let newActiveAllergens = []
          activeAllergens.map(item => {
            newActiveAllergens.push({
              allergen_id: item.allergen_id,
              presence: item.presence
            })
          })
          this.spinner(true)
          let res = await ProductAPI.syncAllergens(this.activeItem.id, newActiveAllergens)
          this.spinner(false)
          this.snackbar({
            text: res.status === 200 ? res.data.msg : res.response.data.errors ? res.response.data.errors[0] : res.response.data.msg,
            open: true,
            color: res.status === 200 ? 'success' : 'error'
          })
        } catch (err) {
          this.spinner(false)
          this.snackbar({
            text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
            open: true,
            color: 'error'
          })
        }
      }
    },

    ...mapActions({
      setAllergenList: 'allergen/setList'
    })
  }
}
</script>
